









































































import Vue from "vue";

export default Vue.extend({
  name: "DialogWrapper",
  props: {
    /** open state of the dialog */
    value: {
      type: Boolean,
      default: false,
    },
    /** title of the dialog */
    title: {
      type: String,
    },
    /** shows a error message */
    error: {
      type: String,
    },
    /** if delete button is shown */
    showDelete: {
      type: Boolean,
      default: false,
    },
    /** if save button is shown */
    showSave: {
      type: Boolean,
      default: true,
    },
    /** if cancel button is shown */
    showCancel: {
      type: Boolean,
      default: true,
    },
    /** define the content text in the content slot */
    content: {
      type: String,
      default: "",
    },
    /** define the save button label */
    saveLabel: {
      type: String,
      default: "Speichern",
    },
    /** define the delete button label */
    deleteLabel: {
      type: String,
      default: "Löschen",
    },
    /** define the cancel button label */
    cancelLabel: {
      type: String,
      default: "Abbrechen",
    },
    /** define the width of the modal, default is auto */
    width: {
      type: String,
      default: "auto",
    },
  },
  data: function () {
    return {
      active: this.value,
    };
  },
  watch: {
    value() {
      this.active = this.value;
    },
  },
  methods: {
    onCancel() {
      this.$emit("input", false);
      this.$emit("cancel");
    },
    onDelete() {
      this.$emit("delete");
      this.onCancel();
    },
    onSave() {
      this.$emit("save");
      this.onCancel();
    },
    /** check if slot exists */
    hasSlot(slot: string) {
      return !!this.$slots[slot];
    },
  },
});
